import { Grid, Link, Stack, Typography } from '@mui/material';
import { type SMBSearchResultWithURL } from '@/types/SearchDirectory';
import { useResponsive } from '@/components/hooks/useResponsive';
import { SMBProfileAvatar } from './SMBProfileAvatar';
import { SMBLocation } from './SMBLocation';
import { SMBRate } from './SMBRate';
import { SMBLicenseVerification } from './SMBLicenseVerification';
import { SMBRating } from './SMBRating';

export interface SMBOverviewProps {
  searchResult: SMBSearchResultWithURL;
}

export const SMBOverview = ({ searchResult }: SMBOverviewProps) => {
  const { isSmallViewport } = useResponsive();
  const url = searchResult.profileURL;
  const targetValue = isSmallViewport ? undefined : '_blank';

  const {
    seoSegmentationProvider: {
      provider: { name, address, avgReviewRating },
      providerRate,
      numberOfReviews,
    },
    licenseVerified,
  } = searchResult;

  return (
    <Grid xs={12} item container columnSpacing={isSmallViewport ? 1.5 : 3}>
      <Grid item sx={{ order: { xs: 2, sm: 0 } }}>
        <Link variant="h3" underline="none" href={url} target={targetValue}>
          <SMBProfileAvatar
            provider={searchResult.seoSegmentationProvider}
            isClientSearchResultsQuery={false}
          />
        </Link>
      </Grid>
      <Grid container item xs alignContent="flex-start">
        <Grid container item xs={9} alignContent="flex-start">
          <Grid item xs={12}>
            <Stack spacing={0.5} alignItems="flex-start">
              <Link
                color="text.primary"
                variant="h3"
                underline="none"
                href={url}
                target={targetValue}>
                <Typography mr={1} display="inline-flex" variant={isSmallViewport ? 'h3' : 'h2'}>
                  {name}
                </Typography>
              </Link>

              {address && <SMBLocation address={address} />}
              {!!avgReviewRating && !isSmallViewport && (
                <SMBRating avgReviewRating={avgReviewRating} numberOfReviews={numberOfReviews} />
              )}
              {providerRate && isSmallViewport && <SMBRate providerRate={providerRate} />}
              {licenseVerified && <SMBLicenseVerification />}
            </Stack>
          </Grid>
        </Grid>
        {providerRate && !isSmallViewport && (
          <Grid item xs={3}>
            <SMBRate providerRate={providerRate} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
